import React from 'react';
import FencedAd from './FencedAd';

export default function createAdVariant(displayName, bannerType) {
  const AdVariant = props => {
    return <FencedAd {...{ ...props, bannerType }} />;
  };

  AdVariant.displayName = displayName;

  return AdVariant;
}
